import HistoryTableToolbar from './HistoryTableToolbar';

export default HistoryTableToolbar;
